export default __webpack_public_path__ + "static/media/otop-hub banner.06f05058.png";